import { useFormContext } from 'react-hook-form';
import { Card } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import * as st from './styles.module.scss';
import { Mode } from './ui/mode';
import { Type } from './ui/type';

export const Format = (): JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext();

  const errorMessage = getErrorMessages(errors, ['event_type']).join(' ');

  return (
    <fieldset className={st.format}>
      <div className={st.format__header}>
        <h3>Формат</h3>
        <p>{errorMessage}</p>
      </div>
      <Card className={st.card}>
        <div className={st.format__mode}>
          <Mode />
        </div>
        <div className={st.format__type}>
          <Type />
        </div>
      </Card>
    </fieldset>
  );
};
